import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/accident.jpg'
import _imports_1 from '@/assets/images/agreement.jpg'
import _imports_2 from '@/assets/images/car-service1.jpg'
import _imports_3 from '@/assets/images/car-crashed.jpg'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "container pt-3 pt-md-4" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_main_carousel = _resolveComponent("main-carousel")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_main_box = _resolveComponent("main-box")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_main_carousel),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createVNode(_component_main_box, {
          "img-src": _imports_0,
          title: "Naprawy powypadkowe"
        }, {
          intro: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode(" Wykonujemy naprawy powypadkowe, głównie obejmujące prace blacharsko-lakiernicze samochodów. ", -1)
          ]))]),
          default: _withCtx(() => [
            _cache[2] || (_cache[2] = _createElementVNode("p", null, [
              _createTextVNode(" Powierzając nam swoje auto mają Państwo pewność, że znajdzie się ono w dobrych rękach. Zapraszamy do bezpośredniej wizyty w warsztacie w Warszawie lub do kontaktu pod numerem telefonu "),
              _createElementVNode("a", { href: "tel:+48790025244" }, "790 025 244"),
              _createTextVNode(". Profesjonalnie obsługujemy klientów z Warszawy i okolic, a także z całej Polski. ")
            ], -1)),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_router_link, {
                to: { name: 'post-crash-repairs' },
                class: "btn btn-primary"
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("Czytaj więcej", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_main_box, {
          "img-src": _imports_1,
          title: "Naprawy bezgotówkowe"
        }, {
          intro: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createTextVNode(" Realizujemy naprawy bezgotówkowe oraz reprezentujemy Klientów przed firmami ubezpieczeniowymi. ", -1)
          ]))]),
          default: _withCtx(() => [
            _cache[5] || (_cache[5] = _createElementVNode("p", null, " Jedyną rzeczą, którą muszą Państwo wykonać jest zgłoszenie szkody do swojego towarzystwa ubezpieczeniowego, a jeśli jest to dla Państwa problemem: zrobimy to za was! Całą resztę spraw związanych z procedurą likwidacji szkody wykona nasz warsztat. ", -1)),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_router_link, {
                to: { name: 'cashless-repairs' },
                class: "btn btn-primary"
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("Czytaj więcej", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_main_box, {
          "img-src": _imports_2,
          title: "Diagnostyka i serwis"
        }, {
          intro: _withCtx(() => [...(_cache[6] || (_cache[6] = [
            _createTextVNode(" Oferujemy serwis oraz diagnostykę samochodów osobowych. Posiadamy najnowsze i specjalistyczne urządzenia diagnostyczno-pomiarowe. ", -1)
          ]))]),
          default: _withCtx(() => [
            _cache[8] || (_cache[8] = _createElementVNode("p", null, " Utrzymamy Państwa pojazd w należytym stanie technicznym wykonując przegląd, diagnosytkę komputerową, wymianę płynów oraz części eksploatacyjnych. ", -1)),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_router_link, {
                to: { name: 'service-diagnostics' },
                class: "btn btn-primary"
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode("Czytaj więcej", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_main_box, {
          "img-src": _imports_3,
          title: "Skup aut powypadkowych"
        }, {
          intro: _withCtx(() => [...(_cache[9] || (_cache[9] = [
            _createTextVNode(" Rozbite, powypadkowe, uszkodzone samochody to niewątpliwie duży problem. Możemy go rozwiązać i odkupić Twój pojazd za gotówkę. ", -1)
          ]))]),
          default: _withCtx(() => [
            _cache[10] || (_cache[10] = _createElementVNode("p", null, " W celu dokonania wyceny wartości swojego samochodu, wystarczy skontaktować się z nami i odwiedzić nasz warsztat. Zajmiemy się wszystkimi formalnościami i sporządzimy umowę kupna-sprzedaży. ", -1))
          ]),
          _: 1
        })
      ])
    ]),
    _cache[11] || (_cache[11] = _createElementVNode("section", { class: "contact bg-primary text-light py-md-3" }, [
      _createElementVNode("div", { class: "container-md" }, [
        _createElementVNode("div", { class: "row" }, [
          _createElementVNode("div", { class: "col-md-7 col-lg-8 col-xl-9 mb-2 mb-md-0" }, [
            _createElementVNode("div", { class: "google-maps" }, [
              _createElementVNode("iframe", {
                src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5030.240777086335!2d20.960663244654757!3d52.23394141691138!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x471ecb92afce1ea9%3A0xf52288e04de5e033!2sAUTO%20PS%20-%20Naprawy%20blacharsko%20-%20lakiernicze!5e0!3m2!1spl!2spl!4v1641763684121!5m2!1spl!2spl",
                width: "600",
                height: "450",
                style: {"border":"0"},
                allowfullscreen: "",
                loading: "lazy"
              })
            ])
          ]),
          _createElementVNode("div", { class: "col-md text-center text-md-right align-self-center" }, [
            _createElementVNode("div", { class: "mb-2" }, [
              _createElementVNode("p", { class: "mb-0" }, [
                _createElementVNode("a", {
                  href: "tel:+48790025244",
                  class: "text-light text-nowrap"
                }, [
                  _createElementVNode("i", { class: "fa fa-phone fa-fw" }),
                  _createTextVNode(" (+48) 790-025-244 ")
                ])
              ]),
              _createElementVNode("p", { class: "mb-0" }, [
                _createElementVNode("a", {
                  href: "mailto:autops.syreny14@gmail.com",
                  class: "text-light text-nowrap"
                }, [
                  _createElementVNode("i", { class: "fa fa-envelope-o fa-fw" }),
                  _createTextVNode(" autops.syreny14@gmail.com ")
                ])
              ])
            ]),
            _createElementVNode("p", null, [
              _createTextVNode(" Auto-PS"),
              _createElementVNode("br"),
              _createTextVNode(" ul. Syreny 14, lok. 06"),
              _createElementVNode("br"),
              _createTextVNode(" 01-132 Warszawa"),
              _createElementVNode("br"),
              _createTextVNode(" NIP: 524-172-34-87"),
              _createElementVNode("br"),
              _createTextVNode(" REGON: 381274682 ")
            ])
          ])
        ])
      ])
    ], -1))
  ]))
}